import { LogLevel } from "@azure/msal-browser";

// pulled from your Azure AD App Registration
const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID, // SPA App (frontend)
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin, // http://localhost:3000 or your prod domain
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage", // persist login
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
        if (level === LogLevel.Info) console.info(message);
        if (level === LogLevel.Verbose) console.debug(message);
        if (level === LogLevel.Warning) console.warn(message);
      },
    },
  },
};

// The scopes your frontend will request (to call your backend API)
export const loginRequest = {
  scopes: [process.env.REACT_APP_AZURE_AD_SCOPE], // e.g. api://backend-client-id/access_as_user
};

export default msalConfig;
